// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"TemplateTableRow_nameCell__aehsA","updatedCell":"TemplateTableRow_updatedCell__tNKRf"};